export interface DayMessage {
  message: string;
}

export interface DayOfWeekMessages {
  Monday: DayMessage[];
  Tuesday: DayMessage[];
  Wednesday: DayMessage[];
  Thursday: DayMessage[];
  Friday: DayMessage[];
  Saturday?: DayMessage[];
  Sunday?: DayMessage[];
}

export const getDayOfWeek = (dayOfWeekNumber: number) => {
  switch (dayOfWeekNumber) {
    case 1:
      return "Monday";
    case 2:
      return "Tuesday";
    case 3:
      return "Wednesday";
    case 4:
      return "Thursday";
    case 5:
      return "Friday";
    case 6:
      return "Saturday";
    case 7:
      return "Sunday";
    default:
      return "Monday";
  }
};

export const COACH_BO_DAY_MESSAGES: DayOfWeekMessages = {
  Monday: [
    {
      message:
        "Happy Monday, $f_name! Let's make this week count. What's your top priority?",
    },
    {
      message:
        "Monday energy! What are you most excited to tackle this week, $f_name?",
    },
    {
      message:
        "Fresh week, fresh start. What's one thing you want to accomplish by Friday?",
    },
    {
      message:
        "Happy Monday, $f_name! Let's set the tone for a great week. What's on your mind?",
    },
    { message: "New week, new opportunities. What are you focusing on today?" },
    {
      message:
        "Monday morning, $f_name! What would make this week feel like a win?",
    },
    {
      message:
        "Happy Monday! Time to turn plans into action. Where are you starting?",
    },
    {
      message:
        "Let's kick off the week strong, $f_name. What's your main focus for the next few days?",
    },
    {
      message: "Monday vibes! What's energizing you as you look at this week?",
    },
    {
      message:
        "New week, new goals, $f_name. What matters most to you right now?",
    },
    {
      message:
        "Happy Monday! Let's make today productive and purposeful. What's first?",
    },
    {
      message:
        "Monday—let's get it, $f_name! What's your biggest opportunity this week?",
    },
    {
      message:
        "Fresh start Monday. What's one thing you're committed to this week?",
    },
    {
      message:
        "Happy Monday, $f_name! Let's build momentum together. What's your focus?",
    },
    { message: "Monday check-in: What would make this week feel successful?" },
    { message: "New week ahead, $f_name! What are you hoping to accomplish?" },
    { message: "Happy Monday! Time to bring your best. What's top of mind?" },
    {
      message:
        "Monday morning energy! What's the most important thing on your plate, $f_name?",
    },
    {
      message:
        "Let's start the week intentionally. What matters most to you today?",
    },
    {
      message:
        "Happy Monday, $f_name! What would you like to make progress on this week?",
    },
  ],
  Tuesday: [
    { message: "Happy Tuesday, $f_name! How's your week shaping up so far?" },
    { message: "Tuesday check-in. What's working well today?" },
    {
      message:
        "It's Tuesday, $f_name—let's keep the momentum going. What are you working on?",
    },
    { message: "Happy Tuesday! What progress have you made since yesterday?" },
    {
      message:
        "Tuesday vibes, $f_name. How are you feeling about your week so far?",
    },
    {
      message:
        "Midweek is coming! What do you want to accomplish before Wednesday?",
    },
    {
      message:
        "Happy Tuesday, $f_name! What's one thing you can move forward today?",
    },
    { message: "Tuesday energy. What's your focus right now?" },
    { message: "How's Tuesday treating you, $f_name? What's on your agenda?" },
    {
      message:
        "Happy Tuesday! Let's keep building on yesterday's progress. What's next?",
    },
    {
      message:
        "Tuesday check-in, $f_name: What's going well, and what needs attention?",
    },
    { message: "It's Tuesday! What's one win you've had so far this week?" },
    { message: "Happy Tuesday, $f_name! How can you make today count?" },
    {
      message: "Tuesday thoughts: What's taking up most of your energy today?",
    },
    { message: "Halfway to Wednesday, $f_name! What are you working toward?" },
    { message: "Happy Tuesday! What would make today feel productive?" },
    { message: "Tuesday momentum, $f_name! What's moving forward?" },
    { message: "How's your Tuesday going? What's top priority?" },
    {
      message:
        "Happy Tuesday, $f_name! Let's make progress together. What's on your mind?",
    },
    { message: "Tuesday check-in. What's one thing you want to tackle today?" },
  ],
  Wednesday: [
    {
      message:
        "Happy Wednesday, $f_name! We're halfway there. How's your week going?",
    },
    { message: "Hump day! What's one thing you can finish by end of day?" },
    {
      message:
        "Happy Wednesday, $f_name! You're in the middle of the week—how are you feeling?",
    },
    {
      message:
        "Wednesday check-in. What momentum can you build for the rest of the week?",
    },
    {
      message:
        "It's Wednesday, $f_name! What would make the second half of your week successful?",
    },
    { message: "Happy hump day! What's your biggest priority right now?" },
    { message: "Wednesday vibes, $f_name. How's your energy today?" },
    { message: "Halfway through the week! What progress are you proud of?" },
    {
      message:
        "Happy Wednesday, $f_name! What do you want to focus on for the next two days?",
    },
    {
      message: "Wednesday check-in: What's working, and what could be better?",
    },
    {
      message:
        "Hump day energy, $f_name! What's one thing you want to push forward today?",
    },
    {
      message:
        "Happy Wednesday! Time to set yourself up for a strong finish. What's next?",
    },
    {
      message:
        "It's Wednesday, $f_name—let's make the rest of the week count. What's your focus?",
    },
    {
      message:
        "Happy Wednesday! What would make you feel good about your week so far?",
    },
    {
      message:
        "Midweek check-in, $f_name. What's taking most of your attention?",
    },
    { message: "Wednesday momentum! What are you making progress on?" },
    { message: "Happy Wednesday, $f_name! How can you make today productive?" },
    {
      message:
        "Hump day thoughts: What's the most important thing you can do today?",
    },
    {
      message:
        "Happy Wednesday, $f_name! Let's finish the week strong. What's on your plate?",
    },
    {
      message:
        "Wednesday check-in. What's one area where you want to make progress?",
    },
  ],
  Thursday: [
    {
      message:
        "Happy Thursday, $f_name! The weekend is in sight. What do you want to wrap up?",
    },
    { message: "Thursday energy! What's left to accomplish before Friday?" },
    {
      message:
        "Happy Thursday, $f_name! How can you set yourself up for a great Friday?",
    },
    {
      message:
        "It's Thursday—almost there! What are you focusing on today, $f_name?",
    },
    {
      message:
        "Happy Thursday! What would make you feel good about your week by tomorrow?",
    },
    {
      message:
        "Thursday check-in, $f_name. What's one thing you want to finish before the weekend?",
    },
    {
      message:
        "Happy Thursday! Let's make these last two days count. What's priority one?",
    },
    { message: "Thursday vibes, $f_name. How's your week looking now?" },
    { message: "It's Thursday! What progress have you made this week?" },
    {
      message:
        "Happy Thursday, $f_name! What's the most important thing you can complete today?",
    },
    { message: "Thursday momentum! What do you want to tackle before Friday?" },
    {
      message:
        "Happy Thursday, $f_name! Time to bring this week home strong. What's on your agenda?",
    },
    {
      message:
        "Almost Friday, $f_name! What would make this week feel complete?",
    },
    {
      message: "Happy Thursday! What are you proud of accomplishing this week?",
    },
    { message: "Thursday check-in: What needs to happen before the weekend?" },
    {
      message:
        "Happy Thursday, $f_name! Let's finish strong. What's your focus?",
    },
    { message: "Thursday thoughts: What's taking your energy today?" },
    {
      message:
        "Happy Thursday, $f_name! What's one win you want to lock in before Friday?",
    },
    {
      message:
        "It's Thursday—time to set up for a smooth Friday. What's most important?",
    },
    {
      message:
        "Happy Thursday, $f_name! What's the biggest thing you want to complete this week?",
    },
  ],
  Friday: [
    { message: "Happy Friday, $f_name! What a week. What went well for you?" },
    {
      message:
        "TGIF! Let's wrap up the week strong. What are you finishing today, $f_name?",
    },
    {
      message:
        "Happy Friday, $f_name! Before you head into the weekend, what's worth celebrating?",
    },
    { message: "Friday vibes! What progress did you make this week?" },
    {
      message:
        "Happy Friday, $f_name! What's one thing you want to complete before the weekend?",
    },
    { message: "It's Friday! How are you feeling about your week, $f_name?" },
    {
      message:
        "Happy Friday! Time to reflect and recharge. What stood out this week?",
    },
    {
      message: "Friday check-in, $f_name. What was your biggest win this week?",
    },
    { message: "Happy Friday, $f_name! What are you proud of accomplishing?" },
    { message: "TGIF! What made this week feel successful?" },
    {
      message:
        "Happy Friday, $f_name! Before the weekend, what's worth acknowledging?",
    },
    { message: "Friday momentum! What did you move forward this week?" },
    {
      message:
        "Happy Friday, $f_name! Hope you have a great weekend planned. What are you up to?",
    },
    {
      message:
        "It's Friday! What's one thing you learned or accomplished this week?",
    },
    {
      message:
        "Happy Friday, $f_name! Let's celebrate the wins. What went well?",
    },
    { message: "Friday reflection: What are you taking away from this week?" },
    {
      message:
        "Happy Friday, $f_name! Time to wrap up and recharge. How was your week?",
    },
    {
      message:
        "TGIF, $f_name! What would make this weekend feel restorative for you?",
    },
    { message: "Happy Friday! Before you log off, what's worth recognizing?" },
    { message: "Friday vibes, $f_name! What's one highlight from your week?" },
  ],
  Saturday: [
    {
      message:
        "Happy Saturday, $f_name! Hope you're enjoying some downtime. How are you recharging?",
    },
    {
      message:
        "Saturday vibes, $f_name! What are you doing to relax this weekend?",
    },
    {
      message:
        "Happy Saturday! Taking time to recharge is just as important as the work week.",
    },
    { message: "Weekend mode, $f_name! What's bringing you joy today?" },
    { message: "Happy Saturday, $f_name! How are you spending your time off?" },
    { message: "Saturday energy! What's helping you reset this weekend?" },
    {
      message:
        "Happy Saturday, $f_name! Hope you're doing something that fills your cup.",
    },
    { message: "Weekend reflection: What are you grateful for this week?" },
    {
      message: "Happy Saturday, $f_name! What's making this weekend feel good?",
    },
    {
      message: "Saturday check-in. How are you taking care of yourself today?",
    },
    {
      message:
        "Happy Saturday, $f_name! What's one thing you're looking forward to?",
    },
    { message: "Weekend vibes! How are you making the most of your downtime?" },
    { message: "Happy Saturday, $f_name! Rest and recharge—you've earned it." },
    { message: "Saturday thoughts: What's bringing you peace today?" },
    {
      message:
        "Happy Saturday, $f_name! What are you doing to disconnect and recharge?",
    },
  ],
  Sunday: [
    { message: "Happy Sunday, $f_name! How are you wrapping up your weekend?" },
    {
      message:
        "Sunday vibes, $f_name! Are you feeling ready for the week ahead?",
    },
    {
      message:
        "Happy Sunday! What's one thing you want to focus on this coming week?",
    },
    {
      message:
        "Sunday reflection, $f_name: What would make next week feel successful?",
    },
    { message: "Happy Sunday, $f_name! How did your weekend treat you?" },
    {
      message:
        "Sunday energy! What are you looking forward to this week, $f_name?",
    },
    { message: "Happy Sunday! Before the week starts, what's on your mind?" },
    { message: "Sunday check-in, $f_name. How are you feeling about Monday?" },
    {
      message: "Happy Sunday, $f_name! What's one priority for the week ahead?",
    },
    {
      message:
        "Sunday thoughts: What do you want to carry into this next week?",
    },
    {
      message:
        "Happy Sunday, $f_name! How can you set yourself up for a great Monday?",
    },
    {
      message:
        "Weekend winding down, $f_name! What's your mindset heading into the week?",
    },
    {
      message:
        "Happy Sunday! What would make this coming week feel meaningful?",
    },
    {
      message:
        "Sunday vibes, $f_name! Are you ready to bring your best this week?",
    },
    {
      message:
        "Happy Sunday, $f_name! What's one thing you're excited about for the week ahead?",
    },
  ],
};
